import React from "react";
import OtpDisabled from "../views/LoginPage/OtpDisabled";
import PasswordChange from "../views/Reset/component/PasswordChange";
import Reset from "../views/Reset/Reset";
import NotFoundPage from "../views/NotFoundPage/NotFoundPage";
import LoginOtpPage from "../views/LoginPage/LoginOtpPage";
import LoginPage from "../views/LoginPage/LoginPage";
import WaitingSignature from "../views/StepsCalculatorPage/Components/PaymentGateway/components/WaitingSignature";
import WaitingValidation from "../views/StepsCalculatorPage/Components/PaymentGateway/components/WaitingValidation";
import WaitingAdvisor from "../views/StepsCalculatorPage/Components/PaymentGateway/components/WaitingAdvisor";
import ClientConsents from "../views/StepsCalculatorPage/Components/PaymentGateway/components/ClientConsents";
import PrePostStackAnimation from "../components/Components/lotties/PrePostStackAnimation";
import NotCoverage from "../views/NotCoverage/NotCoverage";
import { Navigate } from "react-router";
import PostPaymentMain from "../views/Questions/PostPayment/PostPaymentMain";
import BeneficiariesControlCapital from "../views/Questions/PostPayment/components/BeneficiariesControlCapital";
import CardValidation from "../views/CardValidation/CardValidation";
import ProductQuestionsV2 from "../views/Questions/ProductQuestionsV2";
import MedicalQuestionsV2 from "../views/Questions/MedicalQuestionsV2";
import DecisionPage from "../views/DecisionPage/DecisionPage.component";
import ConfirmationPage from "../views/ConfirmationPage/ConfirmationPage.component";
import IncomingUsersPage from "../views/PauseForBreath/IncomingUsersPage.component";
import { GetlifeCalculatorProvider } from "../context/GetLifeCalculator.context";
import CalculatorPageES from "../views/Calculator/ES/CalculatorPageES.component";
import CalculatorPageFR from "../views/Calculator/FR/CalculatorPageFR.component";
import CalculatorPageIT from "../views/Calculator/IT/CalculatorPageIT.component";
import ResumeVelogica from "../views/ResumeVelogica/ResumeVelogica";
import BeneficiariesFreeChoice from "../views/Questions/PostPayment/components/BeneficiariesFreeChoice/BeneficiariesFreeChoice.component";
import BeneficiaryClause from "../views/Questions/PostPayment/components/BeneficiaryClause/BeneficiaryClause";
import PaymentGateway from "../views/StepsCalculatorPage/Components/PaymentGateway/PaymentGateway.component";
import PaymentGatewayV2 from "../views/NewUpsellV2/PaymentGatewayV2.component";
import CandidateModeBoundary from "../views/NewUpsell/Candidates/CandidateModeBoundary";
import RastreatorContainer from "../views/Rastreator/Rastreator";
import Telesubscription from "../views/Telesubscription/Telesubscription";
import FacilePartner from "../views/FacilePartner/FacilePartner";
import AgentConfirmation from "../views/StepsCalculatorPage/Components/PaymentGateway/components/AgentConfirmation";
import CalculatorPageWL_ES from "../views/Calculator/WL_ES/CalculatorPageWL_ES.component";
import TermsAndConditions from "../views/TermsAndConditions/TermsAndConditions";
import PrivacyPolicy from "../views/PrivacyPolicy/PrivacyPolicy";
import PrivacyPolicySummary from "../views/PrivacyPolicySummary/PrivacyPolicySummary";
import CookiesPolicy from "../views/CookiesPolicy/CookiesPolicy";
import NewDashboard from "../views/StepsCalculatorPage/Components/dashboard/NewDashboard";

import { COOKIES_POLICY_PAGE, PRIVACY_POLICY_PAGE, PRIVACY_POLICY_SUMMARY_PAGE, TERMS_AND_CONDITIONS_PAGE } from "./constants/publicRoutes";
// SQL_ES views unified into DecisionPage and ConfirmationPage via layouts
// import DecisionPageSQL from "../views/DecisionPageSQL/DecisionPageSQL.component";
// import ConfirmationPageSQL from "../views/ConfirmationPageSQL/ConfirmationPageSQL.component";
import BeneficiaryIT from "../views/BeneficiaryIT/BeneficiaryIT";
import { BeneficiaryITProvider } from "../context/BeneficiaryIT.context";
import WaitingCustomer from "../views/StepsCalculatorPage/Components/PaymentGateway/components/WaitingCustomer";
import RenewalConfirmation from "../views/StepsCalculatorPage/Components/PaymentGateway/components/RenewalConfirmation";
import MaxCapital from "../views/MaxCapital/MaxCapital";

const domain = process.env.REACT_APP_DOMAIN_LOCALE;

interface ConfigRoutesI {
  path: string;
  component: React.ReactNode;
}

export const redirects: ConfigRoutesI[] = [
  {
    path: "/",
    component: <Navigate to="/login" />,
  },
  {
    path: "/calculator",
    component: <Navigate to="/calculator/1" />,
  },
  {
    path: "/calculatorChallenger",
    component: <Navigate to="/calculatorChallenger/1" />,
  },
];

export const publicRoutes: ConfigRoutesI[] = [
  {
    path: "*",
    component: <NotFoundPage />,
  },
  {
    path: "/notcoverage",
    component: <NotCoverage />,
  },
  {
    path: "/telesubscription",
    component: <Telesubscription />,
  },
  {
    path: "/maxCapital",
    component: <MaxCapital />,
  },
  {
    path: "/partners/rastreator/",
    component: <RastreatorContainer />,
  },
  {
    path: "/partners/facile/",
    component: <FacilePartner />,
  },
  {
    path: "/pause",
    component: <IncomingUsersPage />,
  },
  {
    path: "/pauseAB",
    component: <IncomingUsersPage />,
  },
  {
    path: "/calculator/:stepCalculator",
    component: (
      <GetlifeCalculatorProvider>
        {{
          fr: <CalculatorPageFR />,
          es: <CalculatorPageES />,
          it: <CalculatorPageIT />,
          wl_es: <CalculatorPageWL_ES />,
          sql_es: <Navigate to="/login" />,
        }[domain!]}
      </GetlifeCalculatorProvider>
    ),
  },
  {
    path: "/calculatorChallenger/:stepCalculator",
    component: (
      <GetlifeCalculatorProvider>
        {{
          fr: <CalculatorPageFR />,
          es: <CalculatorPageES />,
          it: <CalculatorPageIT />,
          wl_es: <CalculatorPageWL_ES />,
          sql_es: <Navigate to="/login" />,
        }[domain!]}
      </GetlifeCalculatorProvider>
    ),
  },
  {
    path: "/resumeVelogica",
    component: <ResumeVelogica />,
  },
  {
    path: "/waitingvalidation",
    component: <WaitingValidation />,
  },
  {
    path: "/agent-confirmation",
    component: <AgentConfirmation />,
  },
  {
    path: "/waiting-customer",
    component: <WaitingCustomer />,
  },
  {
    // Alta de un comercial aún en sus manos (estado `advisor_pending` del gateway).
    path: "/waiting-advisor",
    component: <WaitingAdvisor />,
  },
  {
    path: "/renewal-confirmation",
    component: <RenewalConfirmation />,
  },
];

export const protectedRoutes: ConfigRoutesI[] = [
  {
    path: "/login/:otp/:next",
    component: <LoginOtpPage />,
  },
  {
    path: "/login/:otp",
    component: <LoginOtpPage />,
  },
  {
    path: "/pause",
    component: <IncomingUsersPage />,
  },
  {
    path: "/login",
    component: <LoginOtpPage />,
  },
  {
    path: "/otpDisabled",
    component: <OtpDisabled />,
  },
  {
    path: "/reset",
    component: <Reset />,
  },
  {
    path: "/resetDone",
    component: <PasswordChange />,
  },
  {
    path: "/signin",
    component: <LoginPage />,
  },
  {
    path: TERMS_AND_CONDITIONS_PAGE,
    component: <TermsAndConditions />
  },
  {
    path: PRIVACY_POLICY_PAGE,
    component: <PrivacyPolicy />
  },
  {
    path: PRIVACY_POLICY_SUMMARY_PAGE,
    component: <PrivacyPolicySummary />
  },
  {
    path: COOKIES_POLICY_PAGE,
    component: <CookiesPolicy />
  }
];

export const privateRoutes: ConfigRoutesI[] = [
  {
    path: "/animation",
    component: <PrePostStackAnimation />,
  },
  {
    path: "/beneficiaries/:step",
    component: <BeneficiariesFreeChoice />,
  },
  {
    path: "/beneficiaries/5",
    component: <BeneficiariesControlCapital />,
  },
  {
    path: "/beneficiaries/designation/:modality",
    component: <BeneficiaryClause />,
  },
  {
    path: "/card-validation",
    component: <CardValidation />,
  },
  {
    path: "/confirmation",
    component: (
      <>
        {{
          fr: <ConfirmationPage />,
          es: <ConfirmationPage />,
          it: <ConfirmationPage />,
          wl_es: <ConfirmationPage />,
          sql_es: <ConfirmationPage />
        }[domain!]}
      </>
    ), 
  },
  {
    path: "/coverage/:step",
    component: <PostPaymentMain />,
  },
  {
    path: "/beneficiary",
    component: (
      <BeneficiaryITProvider>
        <BeneficiaryIT />
      </BeneficiaryITProvider>
    ),
  },
  {
    // Consentimientos del cliente de un alta del caller (estado `consents_pending`).
    path: "/consents",
    component: <ClientConsents />,
  },
  {
    path: "/dashboard/:section",
    component: <NewDashboard />
  },
  {
    path: "/decision",
    component: (
      <>
        {{
          fr: <DecisionPage />,
          es: <DecisionPage />,
          it: <DecisionPage />,
          wl_es: <DecisionPage />,
          sql_es: <DecisionPage />
        }[domain!]}
      </>
    ),
  },
  {
    path: "/payment/:stepPayment",
    component: <CandidateModeBoundary><PaymentGateway /></CandidateModeBoundary>,
  },
  {
    path: "/paymentChallenger/:stepPayment",
    component: <CandidateModeBoundary><PaymentGateway /></CandidateModeBoundary>,
  },
  {
    path: "/paymentProposed/:stepPayment",
    component: <CandidateModeBoundary><PaymentGateway /></CandidateModeBoundary>,
  },
  {
    path: "/paymentNew/:stepPayment",
    component: <CandidateModeBoundary><PaymentGatewayV2 /></CandidateModeBoundary>,
  },
  {
    path: "/productQuestions",
    component: <ProductQuestionsV2 />,
  },
  {
    path: "/medicalQuestions",
    component: <MedicalQuestionsV2 />,
  },
  {
    path: "/waitingsignature",
    component: <WaitingSignature />,
  },
];
